import React , { Component } from 'react';
import $ from 'jquery';
import Swiper from 'react-id-swiper';
import ReactStars from 'react-stars';
import { Link } from 'react-router';
import { Panel} from 'react-bootstrap';
import { ShareButtons,generateShareIcon } from 'react-share';

const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';


export default class WebTrendings extends Component{
	constructor(props){
		super(props);
		this.state={
			trends:[],
		    event:'',
		    dealid:'',
		}
		this.getTrendings=this.getTrendings.bind(this);
		this.goNext = this.goNext.bind(this);
    	this.goPrev = this.goPrev.bind(this);
    	// this.isActive =this.isActive.bind(this);
    	this.ShareFunc =this.ShareFunc.bind(this);
    	this.swiper = null;
	}
	componentDidMount()
	{
		this.getTrendings();
	}
	getTrendings()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		}
		else
		{
			uid=0;
		}
		var data1={from:'desktop_web',uid:uid,token:localStorage.token};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'getTrendingProducts',
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						trends:data.data,
					});
				   // this.state.trends.map(function(id,index){
                       //this.setState({dealid:id.deal_id});
				   // });

				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	goNext()
	{
	    if(this.swiper) this.swiper.slideNext()
	}
	goPrev()
	{
    	if(this.swiper) this.swiper.slidePrev()
  	}
	  ShareFunc(evnt)
	  {
	  	this.setState({event:evnt});
	  	var data1={from: 'desktop_web',type:1,did:evnt};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'createTinyurl',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data){
	           this.setState({
	              msg: data.msg,
	              shareUrl: data.tinyurl,
	            });
	          }.bind(this),
	          error: function(err){
	            // console.log("Error"+err);
	          }
        });
 		setTimeout(() => {this.setState({event: false}); }, 2000);
	  }
		
	render()
	{
		var trendings=this.state.trends.map(function(product,index){
        var shareUrl=this.state.shareUrl;
        var title="Hey! Click here "+ shareUrl +" to check "+product.title + " deal from AquaDeals.";
        var description=shareUrl;
        return(
        		<div className="col-md-3 col-sm-6">
		            {product.deal_count >=2 ? 
		              <div className="prdt_blk">
		              {product.ad_guarantee_flag === '1' ? <span className="web_ad_guarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt="presentation"/></span> : ''}
		               <Link className="lst_share_btn" onClick={()=>{this.ShareFunc(product.deal_id)}}>
			                <img src={baseAssets+'images/web_imgs/share.png'} alt="Share" />
			           </Link>
			           <Panel className="share_panel"  collapsible expanded={product.deal_id  ===  this.state.event ? true : false}>
			                <FacebookShareButton url={shareUrl} quote={title} className="test_share">
			                  <FacebookIcon size={32} round />
			                </FacebookShareButton>
			                <TwitterShareButton url={shareUrl} quote={title} className="test_share">
			                  <TwitterIcon size={32} round />
			                </TwitterShareButton>
			                <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share">
			                  <GooglePlusIcon  size={32} round />
			                </GooglePlusShareButton>
			            </Panel>
						<Link className="" to={"/web/subdeals/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.dtype+"/"+product.url_brand_name+"/"+product.id} >
			                <div>
			                  <img src={baseAssets+'images/product_imgs/thumbnails/'+product.logo} alt="" />
			               </div>
			                {product.title ? <h3>{product.title}</h3> : <h3>&nbsp;</h3>}
			                {product.brand_name ? <h4>{product.brand_name}</h4> :<h4>&nbsp;</h4>}
			                {product.dealcount >=2 ? <h4>{product.dealcount} deals available</h4> : <h4>&nbsp;</h4>} 
			             </Link>
			             <div className="row stars_view_blk">
		                      <div className="col-md-7 col-xs-7" style={{paddingRight:'0'}}>
		                        <div className="prdt_str_rt">
		                          <ReactStars
		                              count={5}
		                              className={'webRate_blk_item'}
		                              size={17}
		                              value={product.rate >=1 ? product.rate : 0}
		                              edit={false}
		                              color1={'#ccc'}
		                              color2={'#ffc50a'} />
		                        </div>
		                      </div>
		                      <div className="col-md-5 col-xs-5"  style={{paddingLeft:0}}>
		                      	{product.count >0 ? <span className="pro_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt="" /></i>{product.count}</span>: ''}
		                	  </div>
                         </div>
                       </div>  
		            : 
		            <div className="prdt_blk">
		                {product.ad_guarantee_flag === '1' ? <span className="web_ad_guarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt="presentation"/></span> : ''}
		                <Link className="lst_share_btn" onClick={()=>{this.ShareFunc(product.deal_id)}}>
			                  <img src={baseAssets+'images/web_imgs/share.png'} alt="Share" />
			            </Link>
			            <Panel className="share_panel " collapsible expanded={product.deal_id  ===  this.state.event ? true : false}>
			                <FacebookShareButton url={shareUrl} quote={title}  className="test_share">
			                  <FacebookIcon size={32} round />
			                </FacebookShareButton>
			                <TwitterShareButton  url={shareUrl} quote={title} className="test_share">
			                  <TwitterIcon size={32} round />
			                </TwitterShareButton>
			                <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share">
			                  <GooglePlusIcon  size={32} round />
			                </GooglePlusShareButton>
			            </Panel> 
		                <Link key={index} className="pro_blk" to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.id+"/"+product.deal_id} >
			                <div>
			                  <img src={baseAssets+'images/product_imgs/thumbnails/'+product.logo} alt="" />
			                </div>
		                  {product.title ? <h3>{product.title}</h3> : <h3>&nbsp;</h3>}
			              {product.brand_name ? <h4>{product.brand_name}</h4> : <h4>&nbsp;</h4>}
		                 </Link>
		                <div className="row">
			                <div className="col-md-7 col-xs-7" style={{paddingRight:0}}>
			                  <div className="prdt_str_rt" >
		                          <ReactStars
		                              count={5}
		                              className={'webRate_blk_item'}
		                              size={17}
		                              value={product.rate >=1 ? product.rate : 0}
		                              edit={false}
		                              color1={'#ccc'}
		                              color2={'#ffc50a'} />
		                        </div>
			                </div>
			                <div className="col-md-5 col-xs-5" style={{paddingLeft:0}}>
		                  		{product.count >0 ? <span className="pro_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt="" /></i>{product.count}</span>: ''}
		                	</div>
	                	</div>
		           
		           </div> 
		        }
            	</div>
        	)
        }.bind(this));

        var params ={
	   		paginationClickable: true,
		    spaceBetween: 10,
		    slidesPerView: 5,
		    slidesPerGroup: 5,
		    // autoplay:3000,
	      	// autoplayDisableOnInteraction:false,
	     	//  pagination: {
		    //     el: '.swiper-pagination',
		    //     type: 'bullets',
		    //     clickable: true
		    // },
		    // pagination: '.swiper-pagination',
		    navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev'
		    },
   		}
   		

		return(
			
			<section className="container trndg_prdts">
			{this.state.trends.length > 0 ? 
			  <div>	
				<div className="row">
					<h4 className="web_trnd_title">Trending Products</h4>
					<div className="pro_sld_ctrls">
						<a className="left carousel-control pro_sld_lft" onClick={this.goPrev}>
				          <span className="pro_sld_arow"><img src={baseAssets+'images_web/left_arrow.png'} alt="" /></span>
				          <span className="sr-only"></span>
				        </a>
				        <a className="right carousel-control pro_sld_rgt" onClick={this.goNext}>
				          <span className="pro_sld_arow"><img src={baseAssets+'images_web/right_arrow.png'} alt="" /></span>
				          <span className="sr-only"></span>
				        </a>
			        </div>
			    </div>
				<div className="row trndg_prdts_blk">
					<div className="trndg_prdts_sldshow">
						<Swiper {...params} key={this.state.trends.length} ref={node => node ? this.swiper = node.swiper : ''}>
							{trendings}
						</Swiper>
					</div>
				</div>
				<div className="clr">&nbsp;</div>
			</div>	
				:''
		  }
			</section>
		
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Trendings/WebTrendings.js
 **/